/**
 * Utility function to check if sample limit modal should be shown
 * @param {boolean} isSample - Whether the current item is a sample
 * @returns {boolean} - Whether to show the sample limit modal
 */
const shouldShowSampleLimitModal = isSample => {
  if (!isSample) return false;

  // If dynamic data isn't loaded yet, return false (components will handle waiting)
  if (!window.document.pdpDynamicData) return false;

  if (!window.document.pdpDynamicData?.signed_in) return false;
  if (!window.document.pdpDynamicData?.made_sample_enabled) return false; // Feature flip check

  const pdpData = window.document.pdpDynamicData;
  const madeSampleLineItemCount = pdpData?.made_sample_line_item_count || 0;
  const userSampleOrdersCount = pdpData?.user_sample_orders_count || 0;
  const sampleOrderLimit = pdpData?.sample_order_limit || 5;

  return madeSampleLineItemCount >= 1 || userSampleOrdersCount >= sampleOrderLimit;
};

export default shouldShowSampleLimitModal;
